module.exports = __webpack_public_path__ + "img/1552895573.49a93758.jpg";